export default [
    {
        path: 'relatorio-quantitativo-producao',
        component: () => import(
            /* webpackChunkName: 'bpa-relatorio-quantitativo-producao' */
            '@/views/bpa/relatorio-quantitativo-producao/Index'
        ),
        redirect: 'relatorio-quantitativo-producao/index',
        children: [
            {
                name: 'bpa-relatorio-quantitativo-producao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'bpa-relatorio-quantitativo-producao' */
                    '@/views/bpa/relatorio-quantitativo-producao/List.vue'
                ),
            },
        ],
    },
]